import React, { useEffect } from 'react'
import { observer, useLocalStore } from 'mobx-react-lite'
import { Result } from '@odiupsk/up-api-client'
import { Trans } from '@lingui/macro'
import { useRouter } from 'next/router'
import {
  Card,
  CardContent,
  Container,
  Grid,
  GridCol,
  Overlay,
  Section,
} from '../../src/common/ui-kit'
import { IS_DEMO, upAxios } from '../../src/config'
import { logError, logSuccess } from '../../src/common/api/utils'

import { FetchAnon } from '../../src/anon/FetchAnon'
import { ModalChangePassword } from '../../src/common/modules/auth/ModalChangePassword'
import { TabsAuth } from '../../src/common/modules/auth/TabsAuth'
import { getSearchParam } from '../../src/common/utils/routing'
import { useDialog } from '../../src/common/utils/hooks/useDialog'

const TABS = {
  login: 0,
  register: 1,
  0: 'login',
  1: 'register',
} as const

export const PageAuth = observer(function PageAuth() {
  const router = useRouter()
  const d = useDialog()

  const tab = getSearchParam(router.query.tab) || TABS[0]
  const activeTabIndex = TABS[(tab as any) as 'login' | 'register'] || 0

  // this is used to force password change for users with one time generated passwords
  // src/common/utils/hooks/useAuth.ts#L90
  const showChangePassword = getSearchParam(router.query.showChangePassword)
  const verifyRegistrationToken = getSearchParam(router.query.verifyRegistrationToken)

  const state = useLocalStore(
    args => {
      return {
        handleClose() {
          router.replace({
            pathname: router.pathname,
          })
        },
        async handleVerifyRegistration() {
          if (!args.verifyRegistrationToken)
            return console.warn(`verifyRegistrationToken is not set`)

          try {
            const res = await upAxios.post<Result>(
              `/auth/confirm_activation?token=${args.verifyRegistrationToken}`
            )

            logSuccess(res.data.messages?.[0].message ?? '')
            this.handleClose()
          } catch (err) {
            logError(err as any)
            this.handleClose()
          }
        },
      }
    },
    { verifyRegistrationToken }
  )

  useEffect(() => {
    if (showChangePassword != null) d.open()
    else d.close()
  }, [showChangePassword, d])

  useEffect(() => {
    state.handleVerifyRegistration()
  }, [verifyRegistrationToken, state])

  return (
    <main id="main" className="page-auth">
      <Overlay
        bgSrc="/static/img/signup-background.png"
        color="transparent"
        contentClass="no-pad"
        className="bg-turquoise-500"
        imageOnTopRight>
        <Container>
          <Section size="xxlarge">
            <h1 className="h2 text-color-white mb-xxlarge">
              {tab === TABS[0] && <Trans>Prihlásenie</Trans>}
              {tab === TABS[1] && <Trans>Registrácia</Trans>}
            </h1>
            <Grid>
              <GridCol size={{ s: 10, m: 8, l: 6, xl: 5 }}>
                <Card>
                  <CardContent style={IS_DEMO ? { outline: '10px solid red' } : undefined}>
                    <Grid className="align-items-center">
                      <GridCol size={9}>
                        <TabsAuth
                          activeTabIndex={activeTabIndex}
                          onChange={activeTab => {
                            const tabName = TABS[(activeTab as any) as 1 | 0]

                            router.push({
                              pathname: router.pathname,
                              query: {
                                tab: tabName,
                              },
                            })
                          }}
                        />
                      </GridCol>
                    </Grid>
                  </CardContent>
                </Card>
              </GridCol>
            </Grid>
          </Section>
        </Container>
      </Overlay>
      {d.isOpen && <ModalChangePassword close={state.handleClose} />}
    </main>
  )
})

export default () => (
  <FetchAnon>
    <PageAuth />
  </FetchAnon>
)
